module.exports = __webpack_public_path__ + "img/prod-mat_w.ec7dad1b.svg";